<template>
  <div class="price_tab_three_container">
    <div class="warp">
      <h2 class="price_tab_three_title">
        外贸极客 VS 传统外贸营销
      </h2>
      <div class="price_tab_three_desc">
        <div>
          在全球贸易市场竞争日益激烈的背景下，外贸企业急需更高效、更智能的营销推广工具。
          <strong>外贸极客</strong>
          凭借其全方位的智能功能，提供了远超传统方法的效能。
        </div>
      </div>
      <div class="price_tab_three_content">
        <div class="price_tab_three_content_left">
          <div class="price_tab_three_content_left_title">外贸极客</div>
          <div class="left_content">
            <div
              v-for="(item, index) in dataList"
              class="left_content_item"
              :class="{ noBorder: index === 0 }"
            >
              <span class="dot"></span> {{ item }}
            </div>
          </div>
        </div>
        <div class="price_tab_three_content_middle">
          <div class="middle_content">
            <div
              class="middle_content_item"
              v-for="(item, index) in dataList1"
              :class="{ noBorder: index === 0 }"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="price_tab_three_content_left price_tab_three_content_right">
          <div class="price_tab_three_content_left_title">传统外贸营销</div>
          <div class="left_content">
            <div
              class="left_content_item"
              v-for="(item, index) in dataList2"
              :class="{ noBorder: index === 0 }"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/home/推广引流.png";
import img2 from "@/assets/home/快速获客.png";
import img3 from "@/assets/home/高效成交.png";

export default {
  components: {},
  data() {
    return {
      tabValue: 0,
      img1: img1,
      img2: img2,
      img3: img3,
      dataList: [
        "智能翻译、疑难解答、专家建议一应俱齐全，提升效率",
        "快速生成多语言高质量内容，覆盖全球市场",
        "无需专业技术背景，一键生成高质量独立站和站群",
        "一站式管理Facebook和LinkedIn主页，集成互动交流",
        "AI智能化执行日常内容营销推广，效果显著",
        "通过海关数据和全球买家信息精准搜索潜在客户",
        "智能分级和标签管理，全面提升客户管理效能",
        "智能客服和工单管理系统，快速响应客户需求",
      ],
      dataList1: [
        "智能助手",
        "内容生成",
        "智能建站",
        "社媒营销",
        "智能推广",
        "客户搜索",
        "客户管理",
        "售后服务",
      ],
      dataList2: [
        "依赖人力，耗时长效率低，容易出错",
        "需专业人员支撑，时间长，费用高昂",
        "需要聘请技术团队，投入高，周期长",
        "需要分散管理个平台，费时费力，效果有限",
        "手动操作，效率低，效果不稳定",
        "依靠人脉拓展，效率低，数据不全面",
        "缺乏系统支持，人工管理易出错",
        "依赖人力响应，效率低，客户满意度下降",
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
.price_tab_three_container {
  padding-top: 96px;
    position: relative;
    background: #F2F7FF;
    padding-bottom: 96px;
    .warp {
      width: 1200px !important;
      }
  .price_tab_three_title {
    font-family: AlibabaPuHuiTiM;
        font-weight: 500;
font-size: 44px;
color: #262945;
line-height: 52px;
text-align: center;
    }
    .price_tab_three_desc {
      margin: 20px 0;
          font-family: "Alibaba-PuHuiTi-R";
font-size: 20px;
color: #262945;
line-height: 40px;
div {
  width: 780px;
  text-align: center;
  margin: 0 auto;
  }

      }
        .price_tab_three_content {
          display: flex;
          align-items: end;
          margin-top: 60px;
          .noBorder {
            border-top: none !important;
            }
          .price_tab_three_content_left {
            background: #fff;
            border-radius: 20px 0 0 20px;
            height: 590px;
            width: 42%;
            position: relative;
            .price_tab_three_content_left_title {
              position: absolute;
              width: 232px;
height: 55px;
background: linear-gradient( 87deg, #4385FB 0%, #155CFC 100%);
border-radius: 38px;
line-height: 55px;
text-align: center;
color: #fff;
font-weight: 500;
font-size: 22px;
top: -24px;
left: 130px;
              }
            .left_content {
              display: flex;
  flex-direction: column;
  margin: 27px 32px 0 32px;
  row-gap: 22px;
  .left_content_item {
    font-weight: 400;
    border-top: 1px solid #F2F7FF;
    font-size: 16px;
color: #222222;
    padding-top: 22px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    .dot {
      width: 7px;
height: 7px;
background: #1BB84F;
display: inline-block;
border-radius: 50%;
box-shadow: 0px 0px 0px 4px rgba(27,184,79,0.1);
      }
    }
              }
            }
              .price_tab_three_content_middle {
                background: linear-gradient(89deg, #3D88FF 0%, #5596FF 100%);
border-radius: 20px;
height: 603px;
width: 16%;
color: #fff;
.middle_content {
  display: flex;
  flex-direction: column;
  margin: 40px 32px 0 32px;
  row-gap: 22px;
  .middle_content_item {
    border-top: 1px solid rgba(255,255,255,0.2);
    text-align: center;
    font-size: 16px;
    padding-top: 22px;
    }
  }
                }
.price_tab_three_content_right {
  border-radius: 0px 20px 20px 0px;
  .left_content_item {
    color: #666666 !important;
    }
    .price_tab_three_content_left_title {
      background: #AEB9C7 !important;
      }
  }
          }
  }
</style>
